import * as Sentry from '@sentry/browser';

// What is not there is null in the report, so that every event has the same five extras. An empty string is not there either: it is what an ApiError
// that was built with no route has.
const orNull = value => (value === undefined || value === null || value === '' ? null : value);

/**
 * Reports an exception to Sentry, with what finds its cause: the project and the map it was for and, for a typed error (ApiError, NoResponseError), the
 * route, status and code of the request that failed (Global Constraint: "Sentry gets the typed error, the status, the code, the route and the project
 * id"). The SDK's default context is the page and the breadcrumbs of up to nine reads that run side by side, which do not say which of them failed, and
 * the error's own fields are not serialised on the event, so they go on the scope as extras. An error that is not typed has no route, status or code.
 * Only the typed error is sent, never an axios error, which carries the Authorization header.
 * @param {*} error - what was thrown
 * @param {{projectId: ?string, mapName: ?string}} [context] - the project and the map that the failed work was for
 */
export const reportError = (error, {projectId, mapName} = {}) => {
    Sentry.withScope(scope => {
        scope.setExtras({
            projectId: orNull(projectId),
            mapName: orNull(mapName),
            route: orNull(error?.url),
            status: orNull(error?.status),
            code: orNull(error?.code),
        });
        Sentry.captureException(error);
    });
};
